export const permissionManagementTranslations = {
    en: {
        // Page Title
        pageTitleMaster: "Permission Master For",

        // Table Headers
        srNo: "Sr. No.",
        permission: "Permission",
        slug: "Slug",

        // Buttons & Actions
        addPermission: "Add Permission",
        addNewPermission: "Add New Permission",
        updatePermission: "Update Permission",
        deletePermission: "Delete Permission",
        edit: "Edit",
        delete: "Delete",

        // Lists & Messages
        permissionList: "Permission List",
        noPermissionsFound: "No permissions found",
    },
    mr: {
        // Page Title
        pageTitleMaster: "अनुमती मास्टर",

        // Table Headers
        srNo: "क्र. नं.",
        permission: "अनुमती",
        slug: "स्लग",

        // Buttons & Actions
        addPermission: "अनुमती जोडा",
        addNewPermission: "नवीन अनुमती जोडा",
        updatePermission: "अनुमती अद्यतनित करा",
        deletePermission: "अनुमती हटवा",
        edit: "संपादित करा",
        delete: "हटवा",

        // Lists & Messages
        permissionList: "अनुमती सूची",
        noPermissionsFound: "कोणतीही अनुमती सापडली नाही",
    }
};
